import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  radioGroup: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '-10px',
  },
  head : {
    marginTop: "50px",
  },
  styled: {
    // padding: "0px 20px",
    background: "transparent",
  },
  last:{
    margin: "30px 0px",
    letterSpacing: "3px",
  },
  SignInBtn:{
    margin: "0px 20px",
  },
  social: {
    marginBottom: "0px",
  },
  button: {
    marginTop: '40px',
    marginLeft: '100px',
    marginRight: '100px',
  },
}));